module.exports = __webpack_public_path__ + "static/start-web-b4b810cb3928c90f74550fbb772a48a2.jpg";